import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditFAQitem = () => {
    const { id } = useParams();
    const [item, setItem] = useState([]);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/faq-item/${id}`)
            .then((res) => res.json())
            .then((info) => setItem(info));
    }, []);

    const handleAddItem = (event) => {
        event.preventDefault();
        const accodingTitle = event.target.accodingTitle.value;
        const accodingText = event.target.accodingText.value;


        const itemSection = {
            accodingTitle,
            accodingText

        };

        const url = `https://aprilone-178ea8362c0b.herokuapp.com/faq-item/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(itemSection),
        })
            .then((res) => res.json())
            .then((result) => {

                alert(' FAQ Item is Updated');
            });
    };


    return (
        <>
          <HeaderBottom></HeaderBottom>
 
            <section id="services" className="services-area  mt-5 ">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-12 text-center  vh-100">
                                <h3>Update FAQ Text</h3>

                                <form className="contact-form" onSubmit={handleAddItem}>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-12">
                                            <div className="contact-field p-relative c-name ">
                                                <input
                                                    className="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded "
                                                    name="accodingTitle"
                                                    defaultValue={item.accodingTitle}
                                                    placeholder="Accoding Title"
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="contact-field p-relative c-name ">
                                                <input
                                                    className="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded "
                                                    name="accodingText"
                                                    defaultValue={item.accodingText}
                                                    placeholder="Accoding Text"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        

                                        <div className="slider-btn text-center">
                                            <button
                                                className="button-professional"
                                                data-animation="fadeInRight"
                                                data-delay=".8s"
                                            >
                                                Update FAQ Text
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>



        </>
    );
};

export default EditFAQitem;